<template>
	<div class="p-col-12 p-grid">
		<div v-if="!commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getAboutUs2ImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
		</div>

		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p class="login-text justified">We know that success in football is not just about talent; it is also about perseverance, dedication, and hard work. That is why we are constantly striving to improve our platform, to make it more user-friendly, more efficient, and more effective. We are driven by a shared vision of a world where every football player has the opportunity to reach their full potential, regardless of their background or location.</p>
			<p class="login-text justified">At TiroLibre Transfer Platform, we believe that football is more than just a game. It is a way of life, a passion that unites people from all walks of life. We are proud to be part of this incredible community, and we are committed to doing everything in our power to help it grow and thrive.</p>
			<p class="login-text justified">Join us on this amazing journey, and let us help you achieve your goals. Together, we can make football more accessible, more inclusive, and more exciting than ever before.</p>
		</div>
		<div v-if="commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getAboutUs2ImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
		</div>
	</div>

</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -80px;
	font-size: xx-large;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

.margin-list {
	margin-top: -20px;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -40px;
		font-size: x-large;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}

	.margin-list {
		margin-top: -15px;
	}
}
</style>